import * as React from 'react';
import { twMerge } from '@belong/common/twMerge';

const Text = /*#__PURE__*/React.forwardRef(function Text({
  as = 'p',
  variant = 'body',
  fontWeight = 'regular',
  className,
  children,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(as, {
    className: twMerge(variantMap[variant], fontWeightMap[fontWeight], className),
    ...rest,
    ref
  }, children);
});
const variantMap = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  body: 'body',
  p1: 'p1',
  p2: 'p2'
};
const fontWeightMap = {
  regular: 'font-regular',
  semibold: 'font-semibold'
};

export { Text };
